import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import cata from '@/views/cata'
import search from '@/views/search'
import songPage from '@/views/songPage'
import personCenter from '@/views/personCenter'
import collet from '@/views/collet'
import browse from '@/views/browse'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        title: '颂赞圣歌'
      }
  },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta:{
        title: '颂赞圣歌'
      }
    },
    {
      path: '/cata',
      name: 'cata',
      component: cata,
      meta:{
        title: '目录'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta:{
        title: '搜索'
      }
    },
    {
      path: '/songPage',
      name: 'songPage',
      component: songPage,
      meta:{
        title: '颂赞圣歌'
      }
    },
    {
      path: '/personCenter',
      name: 'personCenter',
      component: personCenter,
      meta:{
        title: '我的'
      }
    },
    {
      path: '/collet',
      name: 'collet',
      component: collet,
      meta:{
        title: '我的收藏'
      }
    },
    {
      path: '/browse',
      name: 'browse',
      component: browse,
      meta:{
        title: '浏览记录'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js